module.exports = __webpack_public_path__ + "img/receive_popup_bg.79f5df58.png";